import React, { createContext, useContext } from "react"

const Trip = createContext()
export default function TripContext({
  children,
  latitude,
  longitude,
  ...otherProps
}) {
  return (
    <Trip.Provider value={{ lat: latitude, lng: longitude, ...otherProps }}>
      {children}
    </Trip.Provider>
  )
}

export const useTrip = () => {
  return useContext(Trip)
}
